/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import $ from 'jquery';
import summaryDataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import config from '@bingads-webui-component-legacy/config/index';
import pageContext from '@bingads-webui-static-legacy/page-context';
import constants from '@bingads-webui-static-legacy/constants';
import StepsWizardView from '@bingads-webui-component-legacy/steps-wizard/view/index';
import ModalManager from '@bingads-webui-component-legacy/dialog/modalManager';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';
import * as _preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import CampaignSettingsView from '@bingads-webui-campaign-legacy/crud-campaign/view/create';
import AdGroupUpdateView from '@bingads-webui-campaign-legacy/crud-adgroup/view/update';
import popup from '@bingads-webui-component-legacy/dialog/popup';
import * as instrumentationSvc from '@bingads-webui-campaign-legacy/instrumentation/index';
import * as keywordAdGroupUpdateDecorator from '@bingads-webui-campaign-legacy/crud-adgroup/view/update-keyword-adgroup-decorator';
import * as keywordAdGroupInstru from '@bingads-webui-campaign-legacy/crud-adgroup/share/instrumentKeywordAdGroup';
import * as SuccessDialog from '@bingads-webui-campaign-legacy/campaign-create-advanced/view/success-dialog';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
var preferencesService = _preferencesService.default || _preferencesService;
var modalManager = new ModalManager(i18n.get('Browser_Reload_AlertMessage'));
var campaign2ObjectiveMapping = {
  'search': ['WebsiteVisits', 'LocationVisits', 'WebsiteConversions', 'PhoneCalls', 'AppInstalls'],
  'shopping': ['ShoppingCampaign']
};
var railViewIds = {
  'search': {
    step1: 'SearchCampaignCreate_Step1',
    step2: 'SearchCampaignCreate_Step2',
    step3: 'SearchCampaignCreate_Step3',
    step4: 'SearchCampaignCreate_Step4'
  }
};
var View = StepsWizardView.extend({
  _exitWithSave: function () {
    StepsWizardView.prototype.cancel.call(this).then((function (shouldCancel) {
      if (shouldCancel) {
        this.logToSubstrate('save and exit: successful');
        this.logToSubstrateStop();
        this.navigateToCampaignSummaryPage();
      } else {
        this.logToSubstrate('save and exit: failed');
        setTimeout(function () {
          popup.alert(i18n.get('CampaignCreation_Cancel_AlertMessage'));
        }, 10);
      }
    }).bind(this));
  },
  _cancel: function () {
    this.logToSubstrate('cancel clicked');
    this.logToSubstrateStop();
    this.navigateToRoute('campaign');
  },
  logToSubstrate: function (message) {
    var stepIndex = this.ko_model.stepIndex();
    var api = 'advanced campaign creation';
    this.stepActivities[stepIndex].signal(message, api);
  },
  logToSubstrateStop: function () {
    var stepIndex = this.ko_model.stepIndex();
    var api = 'advanced campaign creation';
    this.stepActivities[stepIndex].stopSignal('campaign creation end', api);
  },
  getAdGroupCreateViewFactory: function () {
    var permissions = config.get('Permissions');
    var isDSAMixedModeCampaignEnabled = permissions.IsDSAMixedModeCampaignEnabled;
    var campaignObjective = config.get('CampaignObjective');
    var campaignType = this.getCampaignType(campaignObjective);
    if (isDSAMixedModeCampaignEnabled && campaignType === 'search') {
      return import(/* webpackMode: 'eager' */'@bingads-webui-campaign-legacy/crud-adgroup/view/mixed-mode-create').then(_MixedModeAdGroupView => {
        return _MixedModeAdGroupView.default;
      });
    }
    var importPromises = [import(/* webpackMode: 'eager' */'@bingads-webui-campaign-legacy/crud-adgroup/view/create'), import(/* webpackMode: 'eager' */'@bingads-webui-campaign-legacy/crud-adgroup/view/create-keyword-adgroup-decorator')];
    return Promise.all(importPromises).spread((_AdGroupView, keywordAdGroupCreateDecorator) => {
      return keywordAdGroupCreateDecorator.decorate(_AdGroupView.default);
    });
  },
  getAdCreateViewFactory: function () {
    return import(/* webpackMode: 'eager' */'@bingads-webui-campaign-legacy/crud-ad/view/create').then(_AdsCreateView => {
      return _AdsCreateView.default;
    });
  },
  getBudgetCreateViewFactory: function () {
    return import(/* webpackMode: 'eager' */'@bingads-webui-campaign-legacy/budget/view/create').then(BudgetCreateView => {
      return BudgetCreateView.default;
    });
  },
  initialize: function (options) {
    if (options && options.perfMarker) {
      this.perfMarker = options.perfMarker;
    }
    var router = _.chain(options.deps).result('router', {}).value();
    this.navigateToRoute = router.navigateToRoute || _.noop;
    this.eventDelegator = _.result(options.deps, 'eventDelegator', {});
    this.isNextButtonEnabled = !(pageContext.Permissions.IsReadOnlyUser || pageContext.CurrentAccountInActive);
    var campaignObjective = config.get('CampaignObjective');
    var campaignSaved = false;
    if (_.isUndefined(campaignObjective)) {
      if (localStorage.supportsStorage()) {
        campaignObjective = localStorage.get('CampaignObjective');
        config.set('CampaignObjective', campaignObjective);
      }
      if (!_.isString(campaignObjective)) {
        this.navigateToRoute('campaign_create_objective');
      }
    }
    var campaignType = this.getCampaignType(campaignObjective);
    var defaultBid = 1;
    this.campaignType = campaignType;
    this.scenario = instrumentationSvc.default[campaignType + 'CampaignCreation'].create();
    this.stepActivities = [];
    this.stepActivities[0] = this.scenario.campaignCreationStep1.create();
    this.stepActivities[1] = this.scenario.campaignCreationStep2.create();
    this.stepActivities[2] = this.scenario.campaignCreationStep3.create();
    this.stepActivities[3] = this.scenario.campaignCreationStep4.create();
    this.stepActivities[0].startSignal();
    this.stepActivities[0].start();
    this.stepActivities[0].stop();
    var permissions = config.get('Permissions');
    var isDSAMixedModeCampaignEnabled = permissions.IsDSAMixedModeCampaignEnabled;
    var description = null;
    var descriptionHelpId = null;
    var descriptionHelpText = null;
    if (isDSAMixedModeCampaignEnabled) {
      description = i18n.get('MixedMode_AdGroupsStepDescription');
    } else {
      description = i18n.get('AdGroupsKeywordsStepDescription');
      descriptionHelpId = 'app54522';
      descriptionHelpText = i18n.get('AdGroupsKeywordsStepDescriptionHelpText');
    }
    _.extend(options || ({}), {
      stageStepLoading: true,
      contentClass: 'advanced-campaign-creation__wrapper',
      enableStepSwitch: true,
      steps: [{
        title: i18n.get('CampaignSettingsStepTitle'),
        pageTitle: i18n.get('CampaignSettingsStep_PageTitle'),
        railViewId: _.result(railViewIds[campaignType], 'step1'),
        description: i18n.get('CampaignSettingsStepDescription'),
        viewFactory: CampaignSettingsView,
        options: {
          campaignType: campaignType,
          showLanguage: true,
          perfMarker: options ? options.perfMarker : null,
          deps: options ? options.deps : {},
          usePanel: options && options.usePanel,
          isForVNext: options && options.isForVNext,
          activityLogger: this.stepActivities[0],
          serverContext: options && options.serverContext,
          scope: options && options.scope
        }
      }, {
        title: isDSAMixedModeCampaignEnabled ? i18n.get('MixedMode_AdGroupsStepTitle') : i18n.get('AdGroupsKeywordsStepTitle'),
        pageTitle: isDSAMixedModeCampaignEnabled ? i18n.get('MixedMode_AdGroupStep_PageTitle') : i18n.get('AdGroupsKeywordsStep_PageTitle'),
        railViewId: _.result(railViewIds[campaignType], 'step2'),
        description: description,
        descriptionHelpId: descriptionHelpId,
        descriptionHelpText: descriptionHelpText,
        viewFactory: _.bind(this.getAdGroupCreateViewFactory, this),
        options: {
          isDelayLoading: true,
          isAutoTargetCampaign: false,
          UpdateView: keywordAdGroupUpdateDecorator.decorate(AdGroupUpdateView),
          instrumentation: keywordAdGroupInstru,
          campaignType: campaignType,
          defaultBid: defaultBid,
          perfMarker: options ? options.perfMarker : null,
          usePanel: options && options.usePanel,
          isForVNext: options && options.isForVNext,
          activityLogger: this.stepActivities[1]
        }
      }, {
        title: i18n.get('AdsAdExtensionStepTitle'),
        pageTitle: i18n.get('AdsAdExtensionStep_PageTitle'),
        railViewId: _.result(railViewIds[campaignType], 'step3'),
        description: i18n.get('AdsAdExtensionStepDescription'),
        viewFactory: _.bind(this.getAdCreateViewFactory, this),
        options: {
          isDelayLoading: true,
          campaignType: campaignType,
          perfMarker: options ? options.perfMarker : null,
          usePanel: options && options.usePanel,
          isForVNext: options && options.isForVNext,
          adExtensionsDynamicFeatures: options && options.adExtensionsDynamicFeatures,
          activityLogger: this.stepActivities[2],
          serverContext: options && options.serverContext
        }
      }, {
        title: i18n.get('BudgetBidsStepTitle'),
        pageTitle: i18n.get('BudgetBidsStep_PageTitle'),
        railViewId: _.result(railViewIds[campaignType], 'step4'),
        description: i18n.get('BudgetBidsStepDescription'),
        viewFactory: _.bind(this.getBudgetCreateViewFactory, this),
        options: {
          isDelayLoading: true,
          accountCurrencyCode: this.options.accountCurrencyCode,
          campaignType: campaignType,
          perfMarker: options ? options.perfMarker : null,
          isForVNext: options.isForVNext,
          activityLogger: this.stepActivities[3],
          i18nNewDesign: _.result(options.deps, 'i18nNewDesign')
        }
      }],
      customButtons: [{
        key: 'next',
        extendDefaultButtons: true,
        extendedParameters: {
          enable: this.isNextButtonEnabled
        }
      }, 'finish', 'back', {
        key: 'exitWithSave',
        cssClass: 'btn-default',
        visible: function () {
          var isLast = this.isLast();
          return !isLast && (campaignSaved || this.maxAvailabeStepIndex() >= 1);
        },
        Text: i18n.get('Button_SaveAndExit'),
        event: _.bind(this._exitWithSave, this)
      }, {
        key: 'cancel',
        cssClass: 'btn-default',
        visible: function () {
          if (this.maxAvailabeStepIndex() >= 1) {
            campaignSaved = true;
          }
          return !campaignSaved;
        },
        Text: i18nGlobal.get('Button_Cancel'),
        event: _.bind(this._cancel, this)
      }]
    });
    modalManager.on();
    StepsWizardView.prototype.initialize.call(this, options);
  },
  render: function () {
    if (_.isFunction(this.options.callbackBeforeRender)) {
      this.options.callbackBeforeRender((function () {
        StepsWizardView.prototype.render.call(this);
      }).bind(this));
    } else {
      StepsWizardView.prototype.render.call(this);
    }
    return this;
  },
  getCampaignType: function (contextValue) {
    var campaignType = 'search';
    _.each(campaign2ObjectiveMapping, function (map, key) {
      if (_.contains(map, contextValue)) {
        campaignType = key;
      }
    });
    return campaignType;
  },
  diaplaySuccessDialog: function () {
    var callback = (function (err, doNotShowAgain) {
      if (err || !doNotShowAgain) {
        var CurrentAccount = config.get('CurrentAccount');
        if (_.isObject(CurrentAccount)) {
          var aid = CurrentAccount.Id;
          var cid = CurrentAccount.AdvertiserCustomerID;
          var isPendingPaymentMethod = CurrentAccount.Status === constants.enums.accountStatus.pendingPaymentInstrument;
          var isAccountOnHold = CurrentAccount.Status !== constants.enums.accountStatus.active;
          var accountPausedReason = constants.enums.accountInactiveReason.notSet;
          if (_.isArray(CurrentAccount.InactiveReasons) && CurrentAccount.InactiveReasons.length > 0) {
            var accountPausedReasons = [constants.enums.accountInactiveReason.pausedDueToSystemIssue, constants.enums.accountInactiveReason.pausedZeroBalance, constants.enums.accountInactiveReason.pausedNoValidiO];
            CurrentAccount.InactiveReasons.some(function (reason) {
              if (accountPausedReasons.indexOf(reason) != -1) {
                accountPausedReason = reason;
                return true;
              } else {
                return false;
              }
            });
          }
          var CurrentUser = config.get('CurrentUser');
          var uid = 0;
          if (_.isObject(CurrentUser)) {
            uid = CurrentUser.Id;
          }
          this.successDialog = new SuccessDialog.default({
            aid: aid,
            cid: cid,
            uid: uid,
            isPendingPaymentMethod: isPendingPaymentMethod,
            isAccountOnHold: isAccountOnHold,
            accountPausedReason: accountPausedReason
          }).show();
        }
      }
    }).bind(this);
    preferencesService.initialize().then(function () {
      var preference = preferencesService.findByName('WebApp.CampaignUI.successDialog') || ({
        Data: {}
      });
      var doNotShowAgain = preference && preference.Data && preference.Data.doNotShowAgain;
      callback(null, doNotShowAgain);
    });
  },
  navigateToCampaignSummaryPage: function () {
    summaryDataContextManager.getContext('/campaign/NewCampaign/Create?');
    this.navigateToRoute('campaign');
    if (!_.isUndefined(pageContext.Permissions) && pageContext.Permissions.IsCampaignCreationSuccessDialogEnabled) {
      this.diaplaySuccessDialog();
    }
    var campaign = this.model.get('Campaign');
    if (!_.isEmpty(campaign) && !_.isEmpty(campaign.Id) && !_.isEmpty(campaign.Name) && this.eventDelegator.trigger) {
      this.eventDelegator.trigger('campaignReload');
    }
  },
  save: function () {
    StepsWizardView.prototype.save.call(this).then((function (shouldNext) {
      if (shouldNext) {
        this.logToSubstrate('save clicked: successful');
        this.logToSubstrateStop();
        var activity = this.scenario.campaignCreationFlowFinished.create();
        activity.start();
        this.navigateToCampaignSummaryPage();
        activity.stop();
        if (this.perfMarker) {
          this.perfMarker.done({
            campaignType: this.campaignType
          });
        }
      } else {
        this.logToSubstrate('save clicked: failed');
      }
    }).bind(this));
  },
  onSwitch: function (args) {
    var delta;
    if (args.delta) {
      delta = args.delta;
    } else if (args.direction === 'next') {
      delta = 1;
    } else {
      delta = -1;
    }
    var stepNumber = args.stepIndex + delta + 1;
    var activity = this.scenario['campaignCreationStep' + stepNumber].create();
    activity.start();
    activity.stop();
    this.stepActivities[args.stepIndex].stopSignal();
    this.stepActivities[stepNumber - 1].startSignal();
  },
  onSwitched: function (args) {
    var target = args.stepTo.$el.closest('.content.content-container').length > 0 ? args.stepTo.$el.closest('.content.content-container') : args.stepTo.$el;
    $('[role=listbox][tabindex=0],:input:enabled,[role=heading][tabindex=-1]', target).filter(':visible:first').focus();
    $(window).trigger('scroll.uiBlock');
  },
  remove: function () {
    if (modalManager.active) {
      modalManager.off();
    }
    if (localStorage.supportsStorage()) {
      localStorage.invalidate('CampaignObjective');
    }
    if (_.isFunction(this.options.callbackBeforeRemove)) {
      this.options.callbackBeforeRemove();
    }
    StepsWizardView.prototype.remove.call(this);
  }
});
export default View;

